module.exports = __webpack_public_path__ + "img/img_doc_id@2x.5b942b4f.png";